export default {"src":"/_next/static/media/vigijobs-colored.177f1479.svg","height":1251,"width":4584,"blurWidth":0,"blurHeight":0};